var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99992 11.0006C3.73472 11.0005 3.48041 10.8951 3.29292 10.7076L0.292919 7.70755C0.110761 7.51895 0.00996641 7.26635 0.0122448 7.00415C0.0145233 6.74195 0.119692 6.49114 0.3051 6.30573C0.490508 6.12033 0.741321 6.01516 1.00352 6.01288C1.26571 6.0106 1.51832 6.11139 1.70692 6.29355L3.90692 8.49355L10.2099 0.386552C10.3728 0.177031 10.6122 0.0407801 10.8755 0.00777372C11.1388 -0.0252327 11.4044 0.0477087 11.6139 0.210552C11.8234 0.373395 11.9597 0.6128 11.9927 0.876101C12.0257 1.1394 11.9528 1.40503 11.7899 1.61455L4.78992 10.6146C4.70296 10.7269 4.59305 10.8195 4.46752 10.886C4.34199 10.9526 4.20372 10.9916 4.06192 11.0006H3.99992Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxTick);
export default __webpack_public_path__ + "static/media/checkbox-tick.02803dfc.svg";
export { ForwardRef as ReactComponent };